import React from 'react'
import { Subtask } from 'constants/interfaces'
import { Button } from 'components/ui'
import { useExecutionLink } from '../../hooks/useExecutionLink'
import { useCourseProgress } from '../../hooks/useCourseProgress'
import { AnswerDraft } from '../../model/execution'
import { useWorkspaceText } from '../../hooks/useWorkspaceText'
import { ExecutionCourseProgress } from '../ExecutionCourseProgress'
import { ExecutionCourseViewer } from '../ExecutionCourseViewer'
import styles from './styles.module.css'

export function ExecutionLinkAnswer({
  subtask,
  disabled,
}: {
  subtask: Subtask
  draft: AnswerDraft
  onChange: (draft: Partial<AnswerDraft>) => void
  disabled: boolean
}) {
  const link = useExecutionLink(subtask)
  const course = useCourseProgress(subtask, link.isViewerOpen)
  const t = useWorkspaceText()

  // A course shows its progress once loaded; a failed request leaves the panel as a plain link.
  const showCourse = course.enabled && !course.failed && (!!course.progress || !course.isLoading)

  const handleViewerClose = () => {
    link.closeViewer()
    // the course may have finished: show its status and the subtask's result at once
    course.reload()
  }

  return (
    <div className={styles.link}>
      <div>
        <strong>{subtask.title}</strong>
        <bdi>{subtask.external_link}</bdi>
        <Button
          type="button"
          variant="primary"
          onClick={link.open}
          isDisabled={disabled || link.isOpening}
          aria-busy={link.isOpening}
        >
          {link.isOpening ? t.saving : link.error ? t.retry : t.openLink}
        </Button>
        {showCourse && <ExecutionCourseProgress progress={course.progress} />}
      </div>
      {link.serviceManaged && <p>{t.externalStatus}</p>}
      {link.error && <p role="alert">{link.error === 'save' ? t.saveError : t.openError}</p>}
      {link.isViewerOpen && <ExecutionCourseViewer subtask={subtask} onClose={handleViewerClose} />}
    </div>
  )
}
